const tapes = [
    {
        tapeNo: '1',
        title: 'Hanne Darboven, <em>Vierjahreszeiten</em>/Robert Barry, <em>Otherwise</em>/Maurizio Nannucci, <em>Words</em>',
        description:
            'The first tape in Sol’s collection includes sound art recordings by artists and longtime friends Hanne Darboven, Robert Barry, and Maurizio Nannucci. By the mid-70s, cassette tapes were a popular way for artists and musicians to share their work.',
    },
    {
        tapeNo: '3',
        title: 'Philip Glass, <em>The Photographer</em> (Muybridge)',
        description:
            '<em>The Photographer</em> by composer Philip Glass is one of the few store-bought tapes in Sol’s collection. ',
    },
    {
        tapeNo: '8',
        title: 'Clara Schumann, <em>3 Romances</em>',
        description:
            'Clara Josephine Schumann was a well-known German pianist and composer born in 1819. Her popularity skyrocketed in the 1970s. She is considered one of the most celebrated pianists of the Romantic era.',
    },
    {
        tapeNo: '20',
        title: 'Laurie Anderson, <em>Big Science</em>, 1982/<em>United States Live</em>, 1984',
        description:
            'Sol taught Laurie Anderson at The School of Visual Arts. He mentored her throughout her career. She acknowledged Sol for inspiring her to make music. Released in 1982, <em>Big Science</em> is Laurie’s first studio album.',
    },
    {
        tapeNo: '22',
        title: 'Beethoven, <em>8 Variation Piano & Piano Sonata 3</em>/Vivaldi, <em>Laudate Pueri</em>',
        description:
            'Classical music was a big part of Sol’s tape collection. He often recorded several composers on one tape. He made detailed notes about each piece, including arrangement and instruments.',
    },
    {
        tapeNo: '38',
        title: 'Wolfgang Amadeus Mozart, <em>Piano Sonata K 135</em>',
        description:
            'Mozart was one of Sol’s favorite composers. “But although anyone can do the kinds of lines that are very precise, only a very few people can do them very well. Perhaps your ten-year-old child can play a Mozart piano sonata, but you wouldn’t pay money to hear it played. If a great pianist were playing it, then you would. There are very sublime ways of making these wall drawings that even I would never have imagined when I first started.”',
    },
    {
        tapeNo: '45',
        title: 'John Cage, <em>Valentine Out of Season & Prelude for Meditation</em>',
        description:
            'Sol admired John Cage and had several of his watercolors, drawings, and prints. His music collection included <em>Score for Changes and Disappearances 18</em>, 1979-82; and "Words for the Satie Society", 1985, a poem by Cage revering French composer Erik Satie (1866-1925).',
    },
    {
        tapeNo: '57',
        title: 'Charles Mingus, <em>East Coasting</em>',
        description: 'Sol loved jazz and blues as much as he loved classical.',
    },

    {
        tapeNo: '533',
        title: 'Gustav Mahler, <em>Symphony #6</em>',
        description:
            'Gustav Mahler (1860-1911) was an Austro-Bohemian Romantic composer and leading conductor of his time. His compositions were banned during WWII. He was later rediscovered by a new generation of listeners. Gustav’s daughter, Anna, was a prominent sculptor who lived in Spoleto, Italy, where Sol also lived in the 1970s. They never met, but the Mahler and LeWitt Studios is a residency program for artists, curators, and writers founded in their honor.',
    },
    {
        tapeNo: '793',
        title: 'Steve Reich, <em>Drumming I</em>',
        description:
            'Sol and Steve Reich were close friends. In 1970, Sol purchased the score for the first version of Steve Reich’s now iconic piece, <em>Drumming</em>, 1970-1971. Fragments of Parts I and IV are considered masterpieces of Minimalism.',
    },
    {
        tapeNo: '821',
        title: 'Claude Debussy (by Pierre Boulez)',
        description:
            'In a 1975 interview, Sol explained his rediscovery of French Impressionist composer Claude Debussy. His works were revisited and recorded by composer Pierre Boulez in the 1960s and 1970s. "The new recordings by Pierre Boulez make them very sharp and clear and not mushy and fuzzy."',
    },
    {
        tapeNo: '857',
        title: 'Philip Glass, <em>Lucinda’s Dance</em>',
        description:
            'In 1979, Sol collaborated with choreographer Lucinda Childs and composer Philip Glass on <em>Dance</em>, presented for the first time at the Brooklyn Academy of Music. Sol contributed a black-and-white film (co-directed with Lisa Rinzler) played in unison with a live dance performance and score by Philip Glass.',
    },
    {
        tapeNo: '955',
        title: 'Bach, <em>Goldberg Variations</em> (Landowska)/<em>Toccata G Minor</em> (Kirkpatrick)',
        description:
            'Sol found inspiration in the system and logic of Bach’s compositions. He credited Bach as an influence on his use of serialism. Sol compared his role as an artist to that of a composer. In a 1974 interview, he considered the work of his wall drawing drafters the same as talented musicians who collaborate: “I always equate it to a musical performance...Whoever does it will leave their mark on it."',
    },
    {
        tapeNo: '1095',
        title: 'Patti Smith, <em>Radio Ethiopia</em>/John Cale and Terry Riley, <em>Church of Anthrax</em>',
        description:
            'This sounds like an awesome mixtape! Sol liked his punk music and avant-garde rock.',
    },
    {
        tapeNo: '1160',
        title: 'Laurie Anderson, <em>Let X=X</em>',
        description:
            'Sol recorded the work of Schubert and Laurie Anderson’s <em>Let X=X</em> on the same tape.',
    },
    {
        tapeNo: '1205',
        title: 'Erik Satie 2 <em>Gymnopedie</em> with St. Saens',
        description:
            'Between 1985 and 1992, composer John Cage invited writers and artists who were fans of Satie’s work, including Sol, to collaborate on his project “First Meeting of the Satie Society.” Sol contributed Cinekus2—drawings alongside a mesostic called “Agenbite of Ouwit". This vertical poem was inspired by a 1963 essay by Canadian philosopher and media theorist Marshall McLuhan.',
    },
    {
        tapeNo: '1211',
        title: 'Duke Ellington, <em>It Don’t Mean a Thing</em> (written on the side of the tape)',
        description:
            'The inclusion of this jazz legend revealed Sol’s appreciation for the greats.',
    },
    {
        tapeNo: '1334',
        title: 'Steve Reich, <em>Tehillim</em>',
        description:
            'Tehillim was written by Steve Reich, an American composer, in 1981. The title means “psalms” in Hebrew.',
    },
    {
        tapeNo: '1431',
        title: 'Amy Beach, <em>Piano Concerto Op 45</em>',
        description:
            'Amy Beach (1867-1944) was America’s first well-known woman composer. Her work became popular again in the 1970s. Sol also had a copy of her piano concerto on vinyl.',
    },
    {
        tapeNo: '2845',
        title: 'Morton Feldman, <em>For Samuel Beckett</em>',
        description:
            'Morton Feldman (1926-1987) was an American composer of indeterminate music. He met Irish novelist/playwright Samuel Beckett in Berlin in 1976. Feldman composed a piece for Beckett’s anti-opera, igniting a professional friendship. Much of Sol’s work was inspired by Beckett and absurdist fiction.',
    },
    {
        tapeNo: '2935',
        title: 'LaMonte Young, <em>On Remembering a Nariad</em> (written on the side of the tape)',
        description:
            'LaMonte Young was an American composer, musician, and performance artist recognized as one of the first minimalist composers. He is known for his post-war avant-garde music and exploration of sustained tones.',
    },
    {
        tapeNo: '3612',
        title: 'Alvin Lucier/Dahinden, <em>Panorama</em>',
        description:
            'Alvin Lucier was an American composer of experimental music and sound installations that explored acoustic phenomena and auditory perception. His <em>Panorama</em> composition was inspired by Sol’s <em>Wall Drawing #730</em>.',
    },
];

export default tapes;
